var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('song-list',{ref:"songlist",attrs:{"title":_vm.keywords,"value":_vm.songs,"loading":_vm.loading,"itemsPerPage":_vm.itemsPerPage},on:{"pageEnd":_vm.getMoreSongs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }